import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import React from 'react'
import TriplePointTakeoverBackground from './components/TriplePointTakeoverBackground'
import TriplePointTakeoverHeroSubtitle from './components/TriplePointTakeoverHeroSubtitle'
import TriplePointTakeoverLogo from './components/TriplePointTakeoverLogo'
import TriplePointTakeoverSearchBanner from './components/TriplePointTakeoverSearchBanner'
import TriplePointTakeoverSearchTileBanner from './components/TriplePointTakeoverSearchTileBanner'

export const triplePointCampaignId = 'triple points june 2025'
export const triplePointsTakeoverId = 'societytriplepoints'

const societyTriplePointsTakeoverConfig: App.SiteTakeoverConfig = {
  id: triplePointsTakeoverId,
  verticals: new Set(['home', 'hotel', 'tours', 'cruise']),
  offerTypes: new Set<App.OfferType>([
    'hotel',
    'tactical_ao_hotel',
    'direct_tour',
    'partner_tour',
    'connection_tour',
    'partner_tour',
    'cruise',
  ]),
  campaignTags: new Set([triplePointCampaignId]),
  palette: 'default',
  backgroundElement: TriplePointTakeoverBackground,
  searchPage: {
    bannerContent: <TriplePointTakeoverSearchBanner />,
    tileBanner: <TriplePointTakeoverSearchTileBanner />,
  },
  offerPage: {
    bannerContent: <Group direction="horizontal" gap={12} verticalAlign="center">
      <TriplePointTakeoverLogo size="small" />
      <b>Enjoy triple bonus points on this limited-time special offer.</b>
    </Group>,
  },
  heroSection: {
    title: 'Curated escapes you’ll love',
    subtitle: <TriplePointTakeoverHeroSubtitle />,
    logo: <CSSBreakpoint min="tablet"><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>,
    palette: 'default',
    verticals: new Set(['home']),
    filters: [
      { label: 'Triple points', value: triplePointCampaignId, type: 'campaignTag' },
      { label: 'Dining & Drinks', value: 'Dining & Drinks', type: 'holidayType' },
      { label: 'Family Friendly', value: 'Family Friendly', type: 'holidayType' },
    ],
  },
}

export default societyTriplePointsTakeoverConfig
